import { Box, Button, Typography, styled } from "@mui/material"
import { colors } from "../../theme/colors"
import { WhiteCard } from "../styled"

export const Container = styled(Box)({
  display: "flex",
  gap: 14,
  alignItems: "flex-start",
  flexDirection: "column",
})

export const DescriptionContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
})

export const CardTopContainer = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  width: "100%",
})

export const CardLabel = styled(Typography)({
  color: colors.lightBlack,
  fontSize: 18,
  lineHeight: "24px",
  fontWeight: 500,
})

export const ChangeButton = styled(Button)({
  display: "contents",
})

export const ToolsContainer = styled(Box)({
  display: "flex",
  alignItems: "center",
  width: "100%",
  gap: "0 14px",
})

export const IconsContainer = styled(ToolsContainer)({
  gap: "10px",
  flexWrap: "wrap",
})

export const Card = styled(WhiteCard)({
  width: "100%",
  boxSizing: "border-box",
  margin: "30px 0",
  display: "flex",
  flexDirection: "column",
})
